import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const ErrorOutline: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z'
        fill={fill}
      />
      <path
        d='M14.4697 8.46973C14.7626 8.17685 15.2374 8.17686 15.5303 8.46973C15.8231 8.76261 15.8231 9.23737 15.5303 9.53027L13.0596 12L15.5293 14.4697L15.581 14.5264C15.8215 14.821 15.804 15.2556 15.5293 15.5303C15.2548 15.8046 14.8209 15.822 14.5264 15.582L14.4687 15.5303L12 13.0605L9.53124 15.5303C9.23841 15.8231 8.76362 15.823 8.4707 15.5303C8.17779 15.2374 8.17782 14.7626 8.4707 14.4697L10.9394 12L8.46972 9.53027L8.41796 9.47363C8.17765 9.17905 8.19512 8.74433 8.46972 8.46973C8.74433 8.19515 9.17906 8.17767 9.47363 8.41797L9.53027 8.46973L12 10.9395L14.4697 8.46973Z'
        fill={fill}
      />
    </svg>
  )
}

export default ErrorOutline
